export const Namespace = 'Document';
export enum DocumentAction {
    DeleteSuccess = 'DOCUMENT_DELETE_SUCCESS',
    RevisionDeleteSuccess = 'REVISION_DELETE_SUCCESS',
    RevisionPromoteSuccess = 'REVISION_PROMOTE_SUCCESS',
    Save = 'DOCUMENT_SAVE'
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/documentView/documentView.actions.ts